import styled from "styled-components";

export const Container = styled.div`
	width: 300px;
	border-radius: 8px;

	.notice-btn {
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: black;

		transition: 200ms ease-out;

		border: solid 3px #3f3f3f;

		.content {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 5px 15px;

			h3 {
				white-space: nowrap;
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 16px;
				font-weight: 600;
				max-width: 200px;
			}

			.icon {
				transition: 300ms;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 10px;
				border-radius: 10px;
				svg {
					color: black;
					font-size: 18px;
					transition: 300ms;
				}
			}
			transition: 300ms;
		}
		.content:hover {
			.icon {
				svg {
					color: white;
				}
				background-color: var(--dark-green);
			}
		}
	}

	.notice-btn:hover {
		scale: 1.01;
		/* border-color: var(--main-green); */
	}
`;
